export default [
  {
    path: '/service-center',
    name: 'service-center',
    component: () => import('@/views/service-center/Index.vue'),
    meta: {
      action: 'read',
      resource: 'Auth',
    },
  },
]
